import React from 'react';
import { Typography, Box } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NatureIcon from '@mui/icons-material/Nature';
import BalanceIcon from '@mui/icons-material/Balance';
import sylwia from '../assets/Sylwisa.jpg';

const values = [
  { icon: NatureIcon, label: 'Naturheilkunde', text: 'Die Natur als Heilerin – ich vertraue auf die Kraft natürlicher Methoden.' },
  { icon: FavoriteIcon, label: 'Ganzheitlichkeit', text: 'Körper, Geist und Seele betrachte ich stets als untrennbare Einheit.' },
  { icon: BalanceIcon, label: 'Individualität', text: 'Jeder Mensch ist einzigartig – meine Behandlungen sind es auch.' },
];

function ÜberMich() {
  return (
    <Box>
      {/* Header Banner */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 60%, #388E3C 100%)',
          py: { xs: 7, md: 10 },
          px: 3,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box sx={{
          position: 'absolute', bottom: -80, left: -80, width: 350, height: 350,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <Typography
          sx={{
            fontFamily: '"Playfair Display", serif',
            fontStyle: 'italic',
            color: '#D4A843',
            fontSize: '1rem',
            letterSpacing: 2,
            textTransform: 'uppercase',
            mb: 1,
          }}
        >
          Über mich
        </Typography>
        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontFamily: '"Playfair Display", serif',
            fontSize: { xs: '1.8rem', md: '2.5rem' },
          }}
        >
          Sylwia Spiller
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mt: 1.5, fontSize: { xs: '0.97rem', md: '1.05rem' } }}>
          Heilpraktikerin mit Leidenschaft für natürliche Heilmethoden
        </Typography>
      </Box>

      {/* Main Content */}
      <Box sx={{ py: { xs: 6, md: 10 }, px: 3, maxWidth: 900, mx: 'auto' }}>

        {/* Photo + Bio */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 4, md: 6 },
            alignItems: { xs: 'center', md: 'flex-start' },
            mb: 8,
          }}
        >
          {/* Portrait */}
          <Box sx={{ flexShrink: 0, textAlign: 'center' }}>
            <Box
              sx={{
                position: 'relative',
                display: 'inline-block',
                borderRadius: '24px',
                boxShadow: '0 0 0 4px #FDFAF4, 0 0 0 7px #D4A843, 0 12px 40px rgba(46,125,50,0.2)',
              }}
            >
              <Box
                component="img"
                src={sylwia}
                alt="Sylwia Spiller"
                sx={{
                  width: { xs: 220, md: 260 },
                  height: { xs: 275, md: 325 },
                  borderRadius: '24px',
                  objectFit: 'cover',
                  objectPosition: 'center 15%',
                  display: 'block',
                }}
              />
            </Box>
            <Typography
              sx={{
                mt: 2.5,
                fontFamily: '"Playfair Display", serif',
                fontStyle: 'italic',
                color: '#D4A843',
                fontSize: '0.9rem',
                letterSpacing: 1,
              }}
            >
              Heilpraktikerin
            </Typography>
          </Box>

          {/* Bio Text */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h5"
              sx={{ fontFamily: '"Playfair Display", serif', color: '#1B5E20', mb: 2.5 }}
            >
              Meine Geschichte
            </Typography>

            <Typography sx={{ color: '#5C5244', lineHeight: 1.95, mb: 2, fontSize: { xs: '0.97rem', md: '1.02rem' } }}>
              Ich bin Sylwia Spiller, Heilpraktikerin mit einer tiefen Leidenschaft für natürliche
              Heilmethoden. Mein Weg in die Naturheilkunde entstand aus der Überzeugung, dass der
              Körper über bemerkenswerte Fähigkeiten zur Selbstheilung verfügt – wenn man ihn
              dabei unterstützt.
            </Typography>
            <Typography sx={{ color: '#5C5244', lineHeight: 1.95, mb: 2, fontSize: { xs: '0.97rem', md: '1.02rem' } }}>
              In meiner Praxis in Berlin verbinde ich traditionelle Heilmethoden mit einem
              modernen, ganzheitlichen Verständnis von Gesundheit. Jede Behandlung beginnt
              mit einem ausführlichen Gespräch – denn ich möchte Sie als ganzen Menschen kennenlernen.
            </Typography>
            <Typography sx={{ color: '#5C5244', lineHeight: 1.95, fontSize: { xs: '0.97rem', md: '1.02rem' } }}>
              Meine Philosophie ist es, Körper, Geist und Seele in Einklang zu bringen und
              die natürliche Balance wiederherzustellen. Ich freue mich darauf, Sie auf Ihrem
              persönlichen Weg zur Gesundheit zu begleiten.
            </Typography>
          </Box>
        </Box>

        {/* Values */}
        <Typography
          variant="h5"
          sx={{ fontFamily: '"Playfair Display", serif', color: '#1B5E20', textAlign: 'center', mb: 5 }}
        >
          Meine Werte
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 3,
            justifyContent: 'center',
          }}
        >
          {values.map(({ icon: Icon, label, text }) => (
            <Box
              key={label}
              sx={{
                flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
                maxWidth: { xs: '100%', sm: 'calc(33.333% - 16px)' },
                textAlign: 'center',
                p: 3.5,
                borderRadius: '20px',
                backgroundColor: '#FDFAF4',
                border: '1px solid rgba(76,175,80,0.12)',
                boxShadow: '0 4px 22px rgba(46,125,50,0.07)',
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 2,
                }}
              >
                <Icon sx={{ fontSize: 28, color: '#2E7D32' }} />
              </Box>
              <Typography
                variant="h6"
                sx={{ fontFamily: '"Playfair Display", serif', color: '#1B5E20', mb: 1, fontSize: '1rem' }}
              >
                {label}
              </Typography>
              <Typography variant="body2" sx={{ color: '#6B6459', lineHeight: 1.75 }}>
                {text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default ÜberMich;
